export const DEFAULT_RULER_OFFSET = 150;
